import React from 'react';
import { Link, useLocation} from 'react-router-dom';
import { GetCurl, GetJCookie, GetUser, Logout, prefix } from './MojaveLib';

function TopNavbar(props) {

    let loc = useLocation().hash;

    return (
        <nav className="top_navbar">
            <div className="container">
                <div className="row clearfix">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="navbar-logo">
                                <Link to={`/${prefix()}/#/${loc}`} className="bars"></Link>
                                <Link className="navbar-brand" to="#/">
                                    <img src="assets/images/logo.svg" width="30" alt="Thyme" />
                                    <span className="ml-2">Thyme</span>
                                </Link>
                            </div>
                            <div className="d-flex justify-content-end justify-content-md-between align-items-center flex-grow-1">
                                <div className="d-flex align-items-center currently_maintain hidden-xs"></div>
                                <ul className="navbar">
                                    <li className="dropdown profile">
                                        <Link to={`/${prefix()}/#/${loc}`} className="dropdown-toggle" data-toggle="dropdown" role="button">
                                            <img className="rounded-circle" src="assets/images/profile_av.png" alt="User" />
                                        </Link>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <div className="user-info">
                                                    <h5 className="user-name mb-0">{GetUser()?.firstname || ''} {GetUser()?.lastname || ''}</h5>
                                                    <p className="user-position font-13">{GetJCookie(`thyme_web${prefix()}_branch`)?.branchName || ''} Branch</p>
                                                </div>
                                            </li>
                                            <li><a href={`#/setup/myprofile`}><i className="icon-user mr-2"></i> <span>My Profile</span> </a></li>
                                            <li><a href={`#/${loc}`} onClick={Logout}><i className="icon-power mr-2"></i><span>Sign Out</span></a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default TopNavbar;